import styled from "styled-components";
import { useState } from "react";

// Components
import FontAwesomeIcon from "../../../../components/common/FontAwesomeIcon";
import CommonButton from "../../../../components/common/CommonButton";

// Assets
import ADIBody from "../../../../assets/media/aden/adi-body.png"
import axios from "axios";

const AnalysisModal = ({ isOpen, onClose, onViewChart, finalAnalysis, sessionId }) => {

    if (!isOpen) return null;

    const handleDownloadResults = async () => {
        const response = await axios.get(
            `https://ai-simulator-api.aden.org/analysis/session/${sessionId}/pdf`
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', 'ResultadoSimulador.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    return (
        <ModalOverlay>
            <ModalContent>
                <Header>
                    <HeaderLeft>
                        <img src={ADIBody} alt="Aden" width={60} height={60} />
                        <HeaderTitle>Análisis de simulación</HeaderTitle>
                    </HeaderLeft>
                    <HeaderRight>
                        <CommonButton
                            label="Ver gráfico con análisis"
                            variant="filled"
                            size="small"
                            onClick={() => {
                                onClose();
                                setTimeout(onViewChart, 300);
                            }}
                            Icon={() => (<div> <FontAwesomeIcon icon="fa-light fa-chart-radar" size={24} /></div>)}
                        />
                        <CloseButton onClick={onClose}>×</CloseButton>
                    </HeaderRight>
                </Header>
                <>
                    <StepTwo>
                        {
                            finalAnalysis.criteria_scores.map((criteria_score) => {
                                return (
                                    <Section>
                                        <SectionTitle>
                                            {criteria_score.name}
                                        </SectionTitle>
                                        <p>
                                            {criteria_score.comment}
                                        </p>
                                    </Section>
                                )
                            })
                        }
                    </StepTwo>
                    <Footer>
                        <ButtonGroup>
                            <CommonButton
                                label="Descargar resultado"
                                variant="outlined"
                                disabled={!sessionId}
                                onClick={handleDownloadResults}
                                Icon={() => (<div><FontAwesomeIcon icon="fa-light fa-arrow-down-to-line" size={24} /></div>)}
                            />
                            <CommonButton
                                label="Compartir resultado"
                                variant="outlined"
                                disabled
                                onClick={() => { }}
                                Icon={() => (<div><FontAwesomeIcon icon="fa-light fa-share-nodes" size={24} /></div>)}
                            />
                        </ButtonGroup>
                    </Footer>
                </>
            </ModalContent>
        </ModalOverlay>
    );
};

export default AnalysisModal;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const ModalContent = styled.div`
    background: white;
    border-radius: 1rem;
    position: relative;
    width: 60vw;
    height: fit-content;
    max-height: 90vh;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    overflow: hidden;
    animation: slideIn 0.3s ease-in-out;

    @keyframes slideIn {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2rem 2rem 1.5rem 2rem;
`;

const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

const HeaderTitle = styled.h2`
    font-size: 36px;
    color: #b31d15;
    margin: 0;
`;

const CloseButton = styled.button`
    position: absolute;
    top: .5rem;
    right: .5rem;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    transition: all 0.3s ease-in-out;

    &:hover {
        background-color: #f5f5f5;
        color: #333;
    }
`;

const IconCircle = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #B31D15;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        color: white;
    }
`;

const StepOne = styled.div`
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    gap: 2rem;
    overflow-y: auto;
    padding: 0 2rem;
    flex: 1;
`;

const StepTwo = styled(StepOne)``;

const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    p {
        font-size: 16px;
        color: #222;
        line-height: 1.5;
        margin: 0;
    }
`;

const SectionTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 24px;
    font-weight: 600;
    color: #b31d15;

    svg {
        color: #B31D15;
    }
`;

const Footer = styled.div`
    width: calc(100% - 4rem);
    display: flex;
    justify-content: ${props => props.single ? 'flex-end' : 'space-between'};
    gap: 1rem;
    padding: 1.5rem 2rem;
    background: white;
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 1rem;
`;
